import React from 'react';
import Form from '../form';
import CountdownTimer from './CountdownTimer';
import { useState, useEffect } from 'react';
const CustomButton = ({ onClick, buttonString, percent }) => (
<button  onClick={onClick}  className="cta-button">BOOK YOUR SPOT</button>
);

export default function PromoSection({url, wholeDate, spotsLeft}) {
  console.log('WHOLEEEEEE', wholeDate)
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [wholeDates, setWholeDates] = useState(0);
  useEffect(() => {
    console.log(wholeDate, 'whole date222222')
    const currentDate = new Date();
    const differenceInMilliseconds = wholeDate - currentDate;
    let day = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
    let hour = Math.floor((differenceInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minute = Math.floor((differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    day = Math.max(day, 0);
    hour = Math.max(hour, 0);
    minute = Math.max(minute, 0);
    console.log(day, hour, minute)
    setDays(day)
    setHours(hour)
    setMinutes(minute)
    setWholeDates(wholeDate)
  }, [wholeDate]);


  useEffect(() => {
    const timerInterval = setInterval(() => {
      setMinutes(prevMinutes => {
        if (prevMinutes > 0) {
          return prevMinutes - 1;
        } else {
          setHours(prevHours => {
            if (prevHours > 0) {
              setMinutes(59);
              return prevHours - 1;
            } else {
              setDays(prevDays => {
                if (prevDays > 0) {
                  setHours(23);
                  setMinutes(59);
                  return prevDays - 1;
                } else {
                  clearInterval(timerInterval);
                  return 0;
                }
              });
            }
          });
        }
      });
    }, 60000);

    return () => clearInterval(timerInterval);
  }, [days, hours, minutes]);
  return (
    <>
      <section className="promo-section">
        <div className="promo-content">
          <div className="promo-title-container">
            <br/>
            <br/>
            <h1 className="promo-title">BREAK FREE</h1>
            <h2 className="promo-subtitle">FROM BOREDOM</h2>
            <br/>
            <p className="promo-tagline">Train For AIM</p>
            <p className="promo-tagline">Train for adventurous lifestyle</p>
          </div>

          <div className="colored-spacer"></div>
          <div className="colored-spacer"></div>
          <div className="colored-spacer"></div>

          <div className="video-wrapper">
            <div className="video-container">
              <iframe
                className="video-player"
                src={`https://www.youtube.com/embed/BylevSjC1EE`}
                title="YouTube video"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="rock-climbing-countdown">
  <CountdownTimer days={days} hours={hours} minutes={minutes} spotsLeft={spotsLeft} />
  <br/>
        <div style={{ textAlign: 'center' }}>
          
          <Form type={'hiking'}  buttonComponent={(toggleModal) => <CustomButton buttonString="BOOK YOUR SPOT IN THIS CRAZY OFFER" onClick={toggleModal} />} />
        </div>
</div>


          <br/>
          <br/>
        </div>

        <div className="slanted-bg">
        <div className="background-video">
          {/* <video autoPlay loop muted playsInline>
            <source src="test2.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}
        </div>
        </div> 

      </section>

      <style>{`
        .promo-section {
          position: relative;
          overflow: hidden;
          text-align: center;
          color: white;
          font-family: 'Calibri', sans-serif;
        }  

        .colored-spacer {
          height: 0.3rem;
          //background-color: rgb(51, 51, 51);
        }

        .background-video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: -1;
          overflow: hidden;
        }

        .background-video video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .slanted-bg {
          position: absolute;
          top: -135px;
          left: 0;
          width: 100%;
          height: 700px;
          background-color: white;
          transform: skewY(-8deg);
          z-index: -1; /* Behind content */
        }

        .promo-title {
          color: rgb(255, 69,0);
          //background-color: rgb(51, 51, 51);
          font-size: 4rem;
          margin: 0;
          font-weight: bold;
          font-family: Futura XBlk BT, sans-serif;
        }

        .promo-subtitle {
          color: rgb(255, 69,0);
          font-size: 3rem;
          //background-color: rgb(51, 51, 51);
          margin: -15px 0 0 0;
          font-weight: bold;
          font-family: Futura XBlk BT, sans-serif;
        }

        .promo-tagline {
          font-size: 2rem;
          margin: 0px 0;
          font-weight: bold;
          //background-color: rgb(51, 51, 51);
          color: black;
          font-family: 'Siro-Bold', sans-serif;
        }

        .promo-title-container {
          //background-color: rgb(51, 51, 51);
        }

       .video-wrapper {
          margin: 20px auto;
          max-width: 800px;
          width: 100%;
        }

       .video-container {
          position: relative;
          width: 100%;
          padding-bottom: 56.25%; /* 16:9 aspect ratio */
          height: 0;
          overflow: hidden;
        }

     .video-container iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .countdown {
          font-family: 'Siro-Bold', sans-serif;
          color: black;
          font-weight: bold;
          font-size: 1.5rem;
          margin: 20px 0;
        }

        .countdown p {
          font-family: 'Calibri', sans-serif;
        }

        .timer {
          font-size: 2rem;
          color: rgb(255, 69,0);
        }

        .timer span {
          margin: 0 5px;
        }

        .cta-button {
          background-color: rgb(255, 69,0);
          color: white;
          padding: 15px 30px;
          border: none;
          font-weight: bold;
          font-size: 1.5rem;
          cursor: pointer;
          font-family: 'Calibri', sans-serif;
        }

        .cta-button:hover {
          background-color: #e65a00;
        }
      .colored-spacer {
          height: 1rem;
          //background-color: rgb(51, 51, 51);
        }

        @media (max-width: 1024px) {
          .video-container {
            max-width: 600px; 
          }
        }

        @media (max-width: 768px) {
          .promo-title, .promo-subtitle {
            font-size: 2rem;
            margin: 0 0 0 0;
          }

          .promo-tagline {
            font-size: 1rem;
          }

        .slanted-bg {
          height: 500px;
        }

          // .timer {
          //   font-size: 1.5rem;
          // }

          .video-container {
            max-width: 90%;
            padding-bottom: 56.25%;
              margin: 0 auto;
          }
          .countdown-text {
            margin: 5px;
          }

          .cta-button {
            font-size: 1.2rem;
            padding: 10px 20px;
          }
        }
      `}</style>
    </>
  );
}
